import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getOperationIndustrieStub } from '../../../../config/operations-industrie';

export default function ChaufferiePage() {
  const parcours = getOperationIndustrieStub('chaufferie');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="industrie"
      segment="operations"
      segmentLabel="Utilités & process"
      crossLinks={[
        {
          label: 'CEE IND-UT / IND-BA',
          href: '/industrie/aides/cee-ind',
          iconName: 'sparkles',
          hint: 'Primes énergie sur la fiche IND-UT-115',
        },
        {
          label: 'Fonds chaleur ADEME',
          href: '/industrie/aides/fonds-chaleur',
          iconName: 'thermometer',
          hint: 'Cumul si passage à une chaufferie biomasse',
        },
        {
          label: 'Calorifugeage',
          href: '/industrie/operations/calorifugeage',
          iconName: 'shield-check',
          hint: 'Compléter par l’isolation des points singuliers',
        },
      ]}
      crossLinksAllLabel="Toutes les aides industrie"
      crossLinksAllHref="/industrie/aides"
    />
  );
}
